import React from 'react';

import { Button } from '../base/Button';
import { Modal } from '../../layouts/Modal';
import { TextField } from '../base/TextField';
import { Form } from '../base/Form/Form';
import { IDocumentResource } from '../../types/Resource/DocumentResource';

interface CreateEditFaultResourceProps {
  open: boolean;
  onClose: (resource?: IDocumentResource) => void;
  resource?: IDocumentResource;
}

interface ResourceFormFields {
  title: string;
  url: string;
}

export default function CreateEditFaultResource({
  open,
  onClose,
  resource,
}: CreateEditFaultResourceProps) {
  const handleClose = () => onClose();

  const handleCreate = (data: ResourceFormFields) => {
    onClose(data);
  };

  const handleUpdate = (data: ResourceFormFields) => {
    onClose(data);
  };

  const handleSubmit = (data: ResourceFormFields) => {
    if (resource) {
      handleUpdate(data);
    } else {
      handleCreate(data);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title={`${resource ? 'Edit' : 'Add'} Resource`}
      description={`Use this form to ${resource ? 'edit' : 'add'} a resource`}
    >
      <Form<ResourceFormFields>
        defaultValues={
          resource
            ? {
                title: resource.title,
                url: resource.url,
              }
            : {}
        }
        onSubmit={handleSubmit}
        className="mt-4 grid grid-cols-1 gap-y-4"
      >
        {({ register }) => (
          <>
            <TextField
              {...register('title', { required: true })}
              label="Resource Title"
              placeholder="Enter resource title"
            />
            <TextField
              {...register('url', { required: true })}
              label="Resource URL"
              placeholder="https://example.com/resource"
              type="url"
            />
            <div className="mt-6 space-x-4">
              <Button type="submit">
                {resource ? 'Update' : 'Add'} Resource
              </Button>
              <Button variant="outlined" onClick={handleClose}>
                Cancel
              </Button>
            </div>
          </>
        )}
      </Form>
    </Modal>
  );
}
